import { SpendAreaStage } from '@sib/api';

export const spendAreaStageColors: Record<SpendAreaStage, string> = {
  [SpendAreaStage.MOBILIZATION]: 'hsl(var(--accent-blue))',
  [SpendAreaStage.SPEND_ESTIMATED]: 'hsl(var(--accent-pink))',
  [SpendAreaStage.NEGOTIATIONS_VENDOR]: 'hsl(var(--warning-vivid))',
  [SpendAreaStage.NEGOTIATIONS_CLIENT]: 'hsl(var(--warning-vivid))',
  [SpendAreaStage.INITIAL_VALIDATION]: 'hsl(var(--success-vivid))',
  [SpendAreaStage.MONITORING_SAVINGS]: 'hsl(var(--accent-violet-vivid))',
};
